import {
	Component,
	Input,
	Output,
	EventEmitter,
	forwardRef,
	ViewEncapsulation,
	ElementRef,
	ViewChild,
	OnDestroy,
	SimpleChanges,
	OnChanges
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IdService, FormControlBase } from '../../shared/index';
import { Observable, fromEvent } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
	selector: 'rbc-tag',
	templateUrl: './tag.component.html',
	styleUrls: ['./tag.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => TagComponent)
		}
	]
})
export class TagComponent extends FormControlBase<boolean> implements OnChanges, OnDestroy {
	@Input() checkable: boolean = false;
	@Input() checked: boolean = false;
	@Input() disabled: boolean | string;
	@Input() height: string;
	@Input() id: string = 'info';
	@Input() name: string = 'info';
	@Input() size: 'small' | 'large';

	@Output() tagUpdate = new EventEmitter();

	@ViewChild('control') $control: ElementRef;
	@ViewChild('tagWrapper') tagWrapper: ElementRef;

	mouseoutObservable: Observable<any>;

	constructor(private idService: IdService) {
		super();
		this.id = idService.generate();
	}

	ngOnChanges(changes: SimpleChanges) {
		super.ngOnChanges(changes);

		if (changes && changes.checked) {
			this.writeValue(changes.checked.currentValue);
		}
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
		super.ngOnDestroy();
	}

	removeFocus() {
		this.$control.nativeElement.blur();
		this.mouseoutObservable = null;
	}

	emitTagUpdate() {
		this.setModel(!this.innerValue);
		this.tagUpdate.emit({ name: this.name, checked: this.innerValue });

		if (!this.mouseoutObservable) {
			this.mouseoutObservable = fromEvent(this.tagWrapper.nativeElement, 'mouseout');

			this.mouseoutObservable.pipe(take(1)).subscribe(this.removeFocus.bind(this));
		}
	}
}
